module.exports = __webpack_public_path__ + "4429869f8f3c32826efd048bf47d4932.png";